import axios from 'axios';
import types from './mutations-types';

const actions = {
  async setListAnswersWordcloud({ commit }, obj) {
    try {
      const resp = await axios.get(
        `${process.env.API_ROOT}/search/wordcloud/${obj.companyId}`,
        { headers: { 'x-access-token': obj.token }, params: { ...obj.params } },
      );

      commit(types.SET_LIST_WORD_CLOUD, resp.data);
    } catch (error) {
      window.console.log(error);
    }
  },

  async setTrashActions({ commit }, obj) {
    const res = await axios.get(
      `${process.env.API_ROOT}/trash/actions/${obj.companyId}`,
      {
        headers: {
          'x-access-token': obj.token,
        },
        params: {
          actionId: obj.actionId,
          groupId: obj.groupId,
          page: obj.page,
          limit: obj.limit,
          startDate: obj.startDate,
          endDate: obj.endDate,
          ih1: obj.ih1,
          ih2: obj.ih2,
        },
      },
    );
    commit(types.SET_TRASH_ACTIONS, res.data);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/answers/actions.js